export const maqueta = {
    text1: "Ont été réalisés",
    text2: "Check-ins",
    text3: "Feuilles de papier économisées 😊",
    text4: "Tous les 100 check-ins, nous plantons un arbre avec",
    text5: "ONE TREE PLANTED",
    text6: "Notifications",
    text7: "Vous n'avez aucune notification",
    text8: "Voir tout",
    text9: "Bienvenue",
    text10: "Entreprise",
    text11: "Tous les hébergements",
    text12: "Profil",
    text13: "Se déconnecter",
    text14: "Désolé, une erreur s'est produite lors de la déconnexion",
    text15: "Le paiement de votre abonnement a été refusé",
    text16: "Pour continuer à utiliser WACheckin, vous devez finaliser votre paiement",
    text17: "Informations de check-in",
    text18: "Données de check-in",
    text19: "Date de la demande :",
    text20: " à",
    text21: "Données collectées lors du check-in du client",
    text22: "Prénom",
    text23: "Nom",
    text24: "Téléphone",
    text25: "Date de séjour",
    text26: "Type de document",
    text27: "Passeport",
    text28: "Carte nationale d'identité",
    text29: "Numéro de document",
    text30: "Informations complémentaires",
    text31: "Expiration du document",
    text32: "Nationalité",
    text33: "Date de naissance",
    text34: "Sexe",
    text35: "Femme",
    text36: "Homme",
    text37: "Fermer",
    text38: "Check-ins",
    text39: "Demandes de service",
    text40: "Hébergements",
    text41: "Ventes croisées",
    text42: "Intégrations",
    text43: "Facturation",

    // Corrections
    p1: "Réservations",

    // Plan validation corrections
    p2: `Passez à un forfait supérieur pour effectuer des check-ins`,
    p3: `Désolé, vous n'avez actuellement aucun abonnement actif ni crédit pour votre hébergement.`,
    p4: `Améliorer le forfait`,

    p5: `Les check-ins ne sont pas disponibles dans cet hébergement.`,
    p6: `Pour plus d'informations, veuillez contacter le propriétaire de l'hébergement.`,

    p7: `Compte non vérifié`,
    p8: `Veuillez consulter votre boîte de réception et confirmer votre compte. Vous n'avez pas reçu l'e-mail ?`,
    p9: `Renvoyer`,
    p10: `Envoi de l'e-mail, veuillez patienter...`,
    p11: `Mon abonnement`,

    p12: `Langue et région`,
    p13: `Choisissez une langue et une région`,
    p14: `Vous pouvez ici voir tous les check-ins effectués.`,
    p15: `Planifiez vos check-ins à l'avance et envoyez-les à vos clients.`,
    p16: `Vous trouverez ici les demandes de service de vos clients, telles que locations, excursions, et plus encore.`,
    p17: `WhatsApp en masse`,
    p18: `Connectez votre compte WhatsApp Business à notre plateforme et activez l'envoi en masse de messages personnalisés à vos clients, rapidement et facilement, directement depuis votre numéro officiel.`,
    p19: `Cette fonctionnalité est encore en cours de développement.`,
    p20: `Informations de check-in`,

    p21: `Informations de check-in`,
    p22: `Check-ins associés`,
    p23: `Aucun check-in associé.`,
    p24: `Plus d'informations :`,
    p25: `Quel hébergement souhaitez-vous gérer ?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
